var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveFromWatchlist(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "#FFFFFF",
    width: "28px",
    className: "css-13o7eu2 e16cqoze0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.205,
    cx: 14,
    cy: 14,
    r: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.56 16.84c-.1 0-.207-.059-.321-.177l-2.857-2.777c-.201-.258-1.319-.721-2.044 0-.726.721-.093 1.747.148 1.989l4.286 4.332c.467.493 1.147.493 1.62 0l9.008-9.62c.524-.546.87-1.53.1-2.228-.768-.699-1.776-.271-2.367.38l-7.243 7.924c-.12.118-.23.177-.33.177Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFromWatchlist);
export default __webpack_public_path__ + "static/media/removeFromWatchlist.d82be21eac7279986a156ea89ee9331b.svg";
export { ForwardRef as ReactComponent };